import PropTypes from "prop-types";
import React from "react";

import ArgonBox from "components/ArgonBox";

import Card from "../components/Card";

const CardItem = ({
  card,
  dragging,
  deleteMode,
  onDelete,
  statusOptions,
  vendors,
  badge,
  numberOfInteractions,
  assignedTo,
}) => {
  console.log("CARD IS", card);
  return (
    <ArgonBox
      key={card.id}
      className={`react-kanban-card${dragging ? " react-kanban-card--dragging" : ""}`}
      sx={{ width: "100%" }}
      draggable={!deleteMode}
      onClick={() => deleteMode && onDelete(card.id, card.columnId)}
    >
      {React.isValidElement(card.template) ? (
        React.cloneElement(card.template, {
          id: card.id,
          statusOptions: statusOptions,
          vendors: vendors,
          badge: badge,
          interactions: numberOfInteractions,
          assignedTo: assignedTo,
        })
      ) : (
        <Card
          content={card.content}
          badge={card.badge}
          progress={card.progress}
          onDelete={() => onDelete(card.id, card.columnId)}
        />
      )}
    </ArgonBox>
  );
};

// PropTypes definitions
CardItem.propTypes = {
  /**
   * Card data object
   */
  card: PropTypes.any.isRequired,

  /**
   * Whether the card is currently being dragged
   */
  dragging: PropTypes.bool,

  /**
   * Whether delete mode is active
   */
  deleteMode: PropTypes.bool,

  /**
   * Function called when card is deleted
   * @param {string|number} cardId - The ID of the card to delete
   * @param {string|number} columnId - The ID of the column containing the card
   */
  onDelete: PropTypes.func.isRequired,
  statusOptions: PropTypes.array,
  vendors: PropTypes.array,
  badge: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ]).isRequired,
    label: PropTypes.string.isRequired,
  }),
  numberOfInteractions: PropTypes.number,
  assignedTo: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.string,
  }),
};

// Default props
CardItem.defaultProps = {
  dragging: false,
  deleteMode: false,
};

export default CardItem;
